export default __webpack_public_path__ + "static/Double-378556c322eff712b713725399d2ee2f.svg";